import React, { FC, useEffect } from 'react';
import { SCUICollapsiblePaper } from '../../../../../atomic/molecules';
import { BillingCommand } from '../../../../../services/command';
import { Grid, Fade, LinearProgress } from '@mui/material';
import Swal from 'sweetalert2';

import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import './SCUIBillingServiceDrawerContent.scss';

export const SCUIBillingServiceDrawerContent: FC<{
    id: number;
    documentType: any;
    onClose?: any;
}> = ({ id, documentType, onClose }) => {
    const [loading, setLoading] = React.useState(true);
    const [documentInfo, setDocumentInfo] = React.useState<any>();
    const [billingRequest, setBillingRequest] = React.useState<any>();
    const [billingLog, setBillingLog] = React.useState<any>();
    const { t } = useTranslation();

    useEffect(() => {
        GetBillingService();
    }, [id]);

    const getParams = (getBillingInformationType: number) => {
        let params: any = {};
        params.referenceID = id;
        params.documentType = documentType;
        params.getBillingInformationType = getBillingInformationType;
        return params;
    };

    const GetBillingService = async () => {
        let documentParams: any = getParams(1);
        let billingRequestParams: any = getParams(2);
        let billingLogParams: any = getParams(3);

        BillingCommand.PostGetBillingInformation(documentParams).then((res: any) => {
            setLoading(false);
            setDocumentInfo(res.data);
        });
        BillingCommand.PostGetBillingInformation(billingRequestParams).then((res: any) => {
            setLoading(false);
            setBillingRequest(res.data);
        });
        BillingCommand.PostGetBillingInformation(billingLogParams).then((res: any) => {
            setLoading(false);
            setBillingLog(res.data);
        });
    };
    function handleCopy(id: any) {
        let copyText = document.getElementById(id)?.innerText;
        if (copyText) {
            navigator.clipboard.writeText(copyText);
            Swal.fire({
                icon: 'success',
                title: t('general.copied'),
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }
    return (
        <Grid className="billing-service-drawer">
            <Grid className="billing-service-drawer-header" container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className="billing-service-drawer-title"
                    size={{
                        md: 11.5,
                        xs: 11.5,
                        lg: 11.5,
                    }}
                >
                    <h1 className="headtxt">
                        {t('general.shippingID')}: {id}
                    </h1>
                </Grid>

                <Grid
                    className="billing-service-drawer-close"
                    size={{
                        md: 0.5,
                        xs: 0.5,
                        lg: 0.5,
                    }}
                >
                    <CloseIcon
                        className="svg_icons billing-service-drawer-close-button"
                        onClick={onClose}
                    />
                </Grid>
            </Grid>
            {!(documentInfo && billingRequest && billingLog) && (
                <Typography className="billing-service-drawer-not-found" variant="h4" sx={{ m: 5 }}>
                    {t('general.notFound')}{' '}
                </Typography>
            )}
            <Fade in={loading}>
                <LinearProgress className="billing-service-drawer-loading" />
            </Fade>
            <Grid className="billing-service-drawer-content" sx={{ margin: '2rem' }}>
                {documentInfo && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('documentInfo')}
                        paperText={'DocumentInfo'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="documentInfo" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(documentInfo), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
                {billingRequest && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('billingRequest')}
                        paperText={'BillingRequest'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="billingRequest" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(billingRequest), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
                {billingLog && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('billingLog')}
                        paperText={'BillingLog'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="billingLog" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(billingLog), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
            </Grid>
        </Grid>
    );
};
